<section class="titleS">
    <h1>Flori</h1>
</section>

<section class="sec">

    <div class="row">
        <div class="col-sm-6 col-xs-6 ">


            <div class="wrapper">
                <div class="container">
                    <div class="top">
                        <img src="/assets/pics/flori/magnoliaroyalstar.jpg" class="img-fluid" alt="Royalstar">
                    </div>
                    <div class="bottom">
                        <div class="left">
                            <div class="details">
                                <h1>Magnolii</h1>
                                <p>Royal Star</p>
                            </div>
                        </div>

                    </div>
                </div>
                <div class="inside">
                    <div class="icon"><i class="material-icons">Detalii</i></div>
                    <div class="contents">
                        <p>Este un arbust decorativ de talie medie. Frunzele cad toamna, raman doar ramurile cu mugurii
                            de flori ce stau peste iarna si se deschid primavara inainte sa porneasca frunzele. Florile
                            albe si deschise sunt asemanatoare cu cele ale crinului. Un copacel perfect cu flori mai
                            diferite decât majoritatea magnoliilor cu flori de tip lalea.</p>
                        <h5>Imagini cu caracter informativ</h5>
                    </div>
                </div>
            </div>

        </div>
        <div class="col-sm-6 col-xs-6 ">
            <h2 class="text-center titletabel">Magnolii</h2>
            <table class="table table-striped  ">
                <thead>
                    <tr>
                        <th scope="col">Nume</th>
                        <th scope="col">Royal Star</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <th scope="row">Dimensiune la livrare(cm)</th>
                        <td>incepand cu 160</td>
                    </tr>
                    <tr>
                        <th scope="row">Inaltime la maturitate(cm)</th>
                        <td>300-450</td>
                    </tr>
                    <tr>
                        <th scope="row">Pret(lei)</th>
                        <td>incepand cu 250</td>
                    </tr>
                    <tr>
                        <th scope="row">Perioada plantare</th>
                        <td>Martie-Noiembrie</td>
                    </tr>
                    <tr>
                        <th scope="row">Cerinte fata de amplasament</th>
                        <td>Soare, semiumbra</td>
                    </tr>

                </tbody>
            </table>


        </div>

    </div>

</section>
<hr>

<section class="sec">

    <div class="row">
        <div class="col-sm-6 col-xs-6 ">


            <div class="wrapper">
                <div class="container">
                    <div class="top">
                        <img src="/assets/pics/flori/susan.jpg" class="img-fluid" alt="susan">
                    </div>
                    <div class="bottom">
                        <div class="left">
                            <div class="details">
                                <h1>Magnolii</h1>
                                <p>Susan</p>
                            </div>
                        </div>

                    </div>
                </div>
                <div class="inside">
                    <div class="icon"><i class="material-icons">Detalii</i></div>
                    <div class="contents">
                        <p style="font-size: 18px;">Face parte din aceeasi familie ca si Magnolia Liliflora Betty. Are
                            flori înguste, in forma de clopotel, roz profund in exterior si rosu deschis in interior.
                            Infloreste bogat chiar si atunci
                            cand planta este tanara, primavara mai tarziu, cand nu risca sa fie deteriorata de
                            temperaturile mai scazute din primavara. Mugurii de flori se produc pe cresterile din
                            anul precedent, astfel ca daca doriti, se poate tunde imediat dupa perioada de
                            inflorire, dar nu mai tarziu. Este de altfel usor de intretinut, suporta majoritatea
                            tipurilor de sol. In perioadele de seceta, se recomanda udarea suplimentara.</p>
                        <h5>Imagini cu caracter informativ</h5>
                    </div>
                </div>
            </div>

        </div>
        <div class="col-sm-6 col-xs-6 ">
            <h2 class="text-center titletabel">Magnolii</h2>
            <table class="table table-striped  ">
                <thead>
                    <tr>
                        <th scope="col">Nume</th>
                        <th scope="col">Susan</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <th scope="row">Dimensiune la livrare(cm)</th>
                        <td>100-120</td>
                    </tr>
                    <tr>
                        <th scope="row">Inaltime la maturitate(cm)</th>
                        <td>300-500</td>
                    </tr>
                    <tr>
                        <th scope="row">Pret(lei)</th>
                        <td>100</td>
                    </tr>
                    <tr>
                        <th scope="row">Perioada plantare</th>
                        <td>Martie-Noiembrie</td>
                    </tr>
                    <tr>
                        <th scope="row">Cerinte fata de amplasament</th>
                        <td>Soare, semiumbra</td>
                    </tr>

                </tbody>
            </table>


        </div>

    </div>

</section>
<hr>

<section class="sec">

    <div class="row">
        <div class="col-sm-6 col-xs-6 ">


            <div class="wrapper">
                <div class="container">
                    <div class="top">
                        <img src="/assets/pics/flori/CaprifoiAmericanBeauty.jpg" class="img-fluid" alt="caprifoi">
                    </div>
                    <div class="bottom">
                        <div class="left">
                            <div class="details">
                                <h1>Caprifoi</h1>
                                <p>American Beauty</p>
                            </div>
                        </div>

                    </div>
                </div>
                <div class="inside">
                    <div class="icon"><i class="material-icons">Detalii</i></div>
                    <div class="contents">
                        <p style="font-size: 18px;">Caprifoiul este o plantă decorativă, urcătoare, care dezvoltă liane lungi, cu frunze ovale, de 1-10 cm lungime.
                            Florile în nuanțe deosebite de roșu închis, galben și portocaliu au un parfum încântător, sunt de formă tubulară și au lungimea de 4 centimetri.
                            Plantele care cresc până la 2-4 m înălțime, au nevoie de sprijin pentru a se putea dezvolta.
                            Caprifoiul este ideal pentru amenajarea grădinilor, oferind un aer exotic acestora.</p>
                        <h5>Imagini cu caracter informativ</h5>
                    </div>
                </div>
            </div>

        </div>
        <div class="col-sm-6 col-xs-6 ">
            <h2 class="text-center titletabel">Caprifoi</h2>
            <table class="table table-striped  ">
                <thead>
                    <tr>
                        <th scope="col">Nume</th>
                        <th scope="col">American Beauty</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <th scope="row">Dimensiune la livrare(cm)</th>
                        <td>100-120</td>
                    </tr>
                    <tr>
                        <th scope="row">Inaltime la maturitate(cm)</th>
                        <td>200-300</td>
                    </tr>
                    <tr>
                        <th scope="row">Pret(lei)</th>
                        <td>40</td>
                    </tr>
                    <tr>
                        <th scope="row">Perioada plantare</th>
                        <td>Martie-Noiembrie</td>
                    </tr>
                    <tr>
                        <th scope="row">Cerinte fata de amplasament</th>
                        <td>Soare</td>
                    </tr>

                </tbody>
            </table>


        </div>

    </div>

</section>
<hr>

<section class="sec">

    <div class="row">
        <div class="col-sm-6 col-xs-6 ">


            <div class="wrapper">
                <div class="container">
                    <div class="top">
                        <img src="/assets/pics/flori/weigeliabristolruby.jpg" class="img-fluid" alt="weigelia">
                    </div>
                    <div class="bottom">
                        <div class="left">
                            <div class="details">
                                <h1>Weigelia</h1>
                                <p>Bristolruby</p>
                            </div>
                        </div>

                    </div>
                </div>
                <div class="inside">
                    <div class="icon"><i class="material-icons">Detalii</i></div>
                    <div class="contents">
                        <p style="font-size: 18px;">Weigela Bristol Ruby este un arbust exotic din familia Caprifoliaceae, ce isi are originea in China, Coreea, Japonia.
                            Inaltimea si diametrul coroanei, in functie de gradul de maturitate si de stadiul de dezvoltare poate ajunge la 3 m.
                            Este o specie ferita de daunatori, cu o rezistenta moderata la ger, sensibila la perioade prelungite de seceta.
                            Weigela are flori lungi de 3 cm, in forma de clopotel, grupate cate 3 - 4, de culoare rosu intens.
                            Frunzele sunt eliptice, usor zimtate, de 5-10 cm lungime.
                            Weigela infloreste foarte abundent in lunile Mai-Iunie (perioada lunga de inflorire).
                            Infloreste bine in plin soare, minim 6 ore pe zi, dar vegeteaza optim si la semiumbra.                            
                            Vegeteaza bine pe solurile nisipo-lutoase, insa bine drenate, cu un grad de umiditate mediu spre ridicat.
                            Se preteaza la tundere care de regula se face toamna. Se poate planta  in diverse grupuri de plante, tufe individuale, gardurii vii de talie mica, parcuri, etc.</p>
                        <h5>Imagini cu caracter informativ</h5>
                    </div>
                </div>
            </div>

        </div>
        <div class="col-sm-6 col-xs-6 ">
            <h2 class="text-center titletabel">Weigelia</h2>
            <table class="table table-striped  ">
                <thead>
                    <tr>
                        <th scope="col">Nume</th>
                        <th scope="col">Bristol Ruby </th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <th scope="row">Dimensiune la livrare(cm)</th>
                        <td>50-80</td>
                    </tr>
                    <tr>
                        <th scope="row">Inaltime la maturitate(cm)</th>
                        <td>200-300</td>
                    </tr>
                    <tr>
                        <th scope="row">Pret(lei)</th>
                        <td>inceoand cu 50</td>
                    </tr>
                    <tr>
                        <th scope="row">Perioada plantare</th>
                        <td>Martie-Noiembrie</td>
                    </tr>
                    <tr>
                        <th scope="row">Cerinte fata de amplasament</th>
                        <td>Soare, semiumbra</td>
                    </tr>

                </tbody>
            </table>


        </div>

    </div>

</section>
<hr>

<section class="sec">

    <div class="row">
        <div class="col-sm-6 col-xs-6 ">


            <div class="wrapper">
                <div class="container">
                    <div class="top">
                        <img src="/assets/pics/flori/syringareflexa.jpg" class="img-fluid" alt="syringa">
                    </div>
                    <div class="bottom">
                        <div class="left">
                            <div class="details">
                                <h1>Syringa</h1>
                                <p>Reflexa</p>
                            </div>
                        </div>

                    </div>
                </div>
                <div class="inside">
                    <div class="icon"><i class="material-icons">Detalii</i></div>
                    <div class="contents">
                        <p style="font-size: 18px;">Syringa reflexa este o specie originara din China, creste ca arbust inalt de 3-4 m, cu coroana larga si ramurile neregulate.
                            Frunzele au forma oblongata sau lanceolata, cu reversul gri, pubescent.
                            Infloreste in luna iunie, formand panicule inguste, cilindrice, pendulare.
                            Florile sunt tubulare, se deschid foarte putin si au culoare roz-inchis, alb in interior.</p>
                        <h5>Imagini cu caracter informativ</h5>
                    </div>
                </div>
            </div>

        </div>
        <div class="col-sm-6 col-xs-6 ">
            <h2 class="text-center titletabel">Syringa</h2>
            <table class="table table-striped  ">
                <thead>
                    <tr>
                        <th scope="col">Nume</th>
                        <th scope="col">Reflexa </th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <th scope="row">Dimensiune la livrare(cm)</th>
                        <td>100-120</td>
                    </tr>
                    <tr>
                        <th scope="row">Inaltime la maturitate(cm)</th>
                        <td>300-400</td>
                    </tr>
                    <tr>
                        <th scope="row">Pret(lei)</th>
                        <td>50</td>
                    </tr>
                    <tr>
                        <th scope="row">Perioada plantare</th>
                        <td>Martie-Noiembrie</td>
                    </tr>
                    <tr>
                        <th scope="row">Cerinte fata de amplasament</th>
                        <td>Soare, semiumbra</td>
                    </tr>

                </tbody>
            </table>


        </div>

    </div>

</section>
<hr>

<section class="sec">

    <div class="row">
        <div class="col-sm-6 col-xs-6 ">


            <div class="wrapper">
                <div class="container">
                    <div class="top">
                        <img src="/assets/pics/flori/physocarpus-opulifolius-diabolo.jpg" class="img-fluid" alt="Physocarpus">
                    </div>
                    <div class="bottom">
                        <div class="left">
                            <div class="details">
                                <h1>Physocarpus</h1>
                                <p>Diabolo</p>
                            </div>
                        </div>

                    </div>
                </div>
                <div class="inside">
                    <div class="icon"><i class="material-icons">Detalii</i></div>
                    <div class="contents">
                        <p style="font-size: 18px;">Physocarpus opulifolius Diabolo este un arbust ornamental extrem de apreciat. Soiul face parte din familia Rosaceae.
                            Frunzisul sau decorativ in nuante de violet-purpuriu inchis creeaza tufisuri mari, dense si compacte.
                            Ramurile puternic impodobite sunt usor arcuite.
                            Frunzele cresc sub forma lombata iar in perioada de inflorire arbustul devine puternic impodobit cu flori albe care cresc in buchete</p>
                        <h5>Imagini cu caracter informativ</h5>
                    </div>
                </div>
            </div>

        </div>
        <div class="col-sm-6 col-xs-6 ">
            <h2 class="text-center titletabel">Physocarpus</h2>
            <table class="table table-striped  ">
                <thead>
                    <tr>
                        <th scope="col">Nume</th>
                        <th scope="col">Diabolo </th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <th scope="row">Dimensiune la livrare(cm)</th>
                        <td>80-100</td>
                    </tr>
                    <tr>
                        <th scope="row">Inaltime la maturitate(cm)</th>
                        <td>150-250</td>
                    </tr>
                    <tr>
                        <th scope="row">Pret(lei)</th>
                        <td>incepand cu 50</td>
                    </tr>
                    <tr>
                        <th scope="row">Perioada plantare</th>
                        <td>Martie-Noiembrie</td>
                    </tr>
                    <tr>
                        <th scope="row">Cerinte fata de amplasament</th>
                        <td>Soare, semiumbra</td>
                    </tr>

                </tbody>
            </table>


        </div>

    </div>

</section>
<hr>

<section class="sec" id="ultim">

    <div class="row">
        <div class="col-sm-6 col-xs-6 ">


            <div class="wrapper">
                <div class="container">
                    <div class="top">
                        <img src="/assets/pics/flori/trandafir.jpg" class="img-fluid" alt="trandafir">
                    </div>
                    <div class="bottom">
                        <div class="left">
                            <div class="details">
                                <h1>Trandafir pe picior</h1>
                                <p>Red</p>
                            </div>
                        </div>

                    </div>
                </div>
                <div class="inside">
                    <div class="icon"><i class="material-icons">Detalii</i></div>
                    <div class="contents">
                        <p style="font-size: 18px;">Trandafirii pe picior au aceasta denumire deoarece au o forma de
                            pomisor, cu trunchi subtire si o coroana bogata de flori.</p>
                        <p style="font-size: 18px;">In ghiveci sau in gradina el va avea nevoie de destul de multa apa.
                            Se va avea grija sa fie udat de doua-trei ori pe saptamana. Atentie, cel care face de obicei
                            operatia de udare va
                            verifica pamantul destul de des pentru ca acesta sa nu se usuce. Singura perioada in care
                            vom reduce frecventa udarilor va fi atunci cand trandafirul se afla in repaus vegetativ.
                            Atunci, acesta va avea nevoie de apa o singura data pe saptamana. De asemenea, pentru o
                            dezvoltare sanatoasa va recomandam sa-l tratati cu ingrasamant lichid pentru trandafiri </p>

                        <h5>Imagini cu caracter informativ</h5>
                    </div>
                </div>
            </div>

        </div>
        <div class="col-sm-6 col-xs-6 ">
            <h2 class="text-center titletabel">Trandafiri</h2>
            <table class="table table-striped  ">
                <thead>
                    <tr>
                        <th scope="col">Nume</th>
                        <th scope="col">Red</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <th scope="row">Dimensiune la livrare(cm)</th>
                        <td>100</td>
                    </tr>
                    <tr>
                        <th scope="row">Culori disponibile</th>
                        <td>Rosu,Alb,Galben,mov,</td>
                    </tr>
                    <tr>
                        <th scope="row">Inaltime la maturitate(cm)</th>
                        <td>120-140</td>
                    </tr>
                    <tr>
                        <th scope="row">Pret(lei)</th>
                        <td>120</td>
                    </tr>
                    <tr>
                        <th scope="row">Perioada plantare</th>
                        <td>Martie-Noiembrie</td>
                    </tr>
                    <tr>
                        <th scope="row">Cerinte fata de amplasament</th>
                        <td>Soare,semiumbra</td>
                    </tr>

                </tbody>
            </table>


        </div>

    </div>

</section>
<hr>